module.exports = __webpack_public_path__ + "static/Tray02-95ece71397a2da4ebdfdce3168653164.png";